module.exports = __webpack_public_path__ + "static/media/map-marker-smile.4754a88f.svg";